// extracted by mini-css-extract-plugin
export default {"component":"EjT-c","tool-container":"mg6My","tool-description":"BiBRU"};